import React from "react";
import { SbSwitch, SbTooltip } from "uiCore";
import { ORG_VIEW_LAYOUT } from "../orgDesign.constants";
import { LayoutSwitchStyled, LayoutSwitchLabelStyled, LayoutOptionStyled } from "../orgDesign.styles";

export const LAYOUT_SWITCH_DISABLED_NOTE = "Only one chart: this design has no changes";

// "Layout:  Up and down  [switch]  Side by side". Off = stacked (the
// default), on = side by side; both options stay visible with the active
// one bold, like the Jobs Library "View By" switch. `disabled` when Org View
// shows a single chart, with a hover note saying why. The tooltip sits on
// the wrapper because a disabled switch doesn't fire the hover events the
// tooltip needs.
const OrgViewLayoutSwitch = ({ layout, onChange, disabled = false }) => {
  const isSideBySide = layout === ORG_VIEW_LAYOUT.SIDE_BY_SIDE;

  return (
    <SbTooltip content={LAYOUT_SWITCH_DISABLED_NOTE} disabled={!disabled}>
      <LayoutSwitchStyled $disabled={disabled}>
        <LayoutSwitchLabelStyled>Layout:</LayoutSwitchLabelStyled>
        <LayoutOptionStyled $active={!isSideBySide} $disabled={disabled}>Up and down</LayoutOptionStyled>
        <SbSwitch
          size="small"
          checked={isSideBySide}
          disabled={disabled}
          aria-label="Show Current and Proposed side by side"
          onChange={(checked) => onChange(checked ? ORG_VIEW_LAYOUT.SIDE_BY_SIDE : ORG_VIEW_LAYOUT.STACKED)}
        />
        <LayoutOptionStyled $active={isSideBySide} $disabled={disabled}>Side by side</LayoutOptionStyled>
      </LayoutSwitchStyled>
    </SbTooltip>
  );
};

export default OrgViewLayoutSwitch;
